import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.scss';

export const LOG_IN = 'log_in';
export const SIGN_UP = 'sign_up';

const ButtonWrapper = ({ children, className, ...options }) => {
  return (
    <button
      className={`${styles.authButton} ${className}`}
      variant="primary"
      type="button"
      {...options}
    >
      {children}
    </button>
  );
};

ButtonWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

export default ButtonWrapper;
